var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.33594 15L2.33594 6.83333C2.33594 3.88781 4.72376 1.5 7.66927 1.5L15.8359 1.5M10.3359 25.5L19.3359 25.5C20.9928 25.5 22.3359 24.1569 22.3359 22.5L22.3359 9.5C22.3359 7.84315 20.9928 6.5 19.3359 6.5L10.3359 6.5C8.67909 6.5 7.33594 7.84314 7.33594 9.5L7.33594 22.5C7.33594 24.1569 8.67908 25.5 10.3359 25.5Z",
    stroke: "#657397",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/Ic_Copy.b5b52981c5b1b25ded790c1a7b35de67.svg";
export { ForwardRef as ReactComponent };